import { partitionObject } from '../../utils';
/**
 * Splits `Indicator` properties into `label` and `input` props.
 */
export const splitContainerProps = (props) => partitionObject(props, ([key]) => containerProps.test(key));
const containerProps = /^aria-|^data-/;
//# sourceMappingURL=splitContainerProps.js.map